import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import StatusViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Status';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import TextRenderer from '../../../TextRenderer';
import { ShortStatusViewer, LongStatusViewer } from '../../../DaEditorWrapper/Viewer/Status';
import { getIsShortStatus, getStatusBackgroundProps } from '../../_helpers';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import Background from '../../../Background';
import SubPaywall from '../_partials/SubPaywall';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import s from './Status.scss';
export const StatusFullView = ({ deviation: { textContent }, deviation, width })=>{
    const backgroundProps = getStatusBackgroundProps(deviation);
    const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    if (isBlocked) {
        return /*#__PURE__*/ React.createElement(SubPaywall, {
            deviation: deviation,
            isStatusArtStage: true
        });
    }
    if (!textContent) {
        return null;
    }
    if (!textContent || !(textContent.excerpt || textContent.html.markup)) {
        return null;
    }
    // Display logic
    // Legacy gets its own styles
    // If any media inserted it cant be short
    const isLegacy = textContent.html.type === 'writer';
    const isShortStatus = getIsShortStatus(deviation);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isLegacy && s['legacy'], isShortStatus && s['short-status'])
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement(React.Fragment, null, backgroundProps && /*#__PURE__*/ React.createElement(Background, _object_spread({
        className: s['background-wrapper'],
        width: width,
        variant: "status"
    }, backgroundProps)), /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: textContent,
        className: s['text'],
        reactViewer: isShortStatus ? ShortStatusViewer : LongStatusViewer,
        legacyTheme: isShortStatus ? 'short-status' : 'status',
        viewerKey: deviation.deviationId,
        width: '100%',
        tipTapViewer: StatusViewer,
        cookieType: MeasuredCookieType.EDITOR_STATUS,
        defaultSize: {
            desktop: {
                width: 780,
                height: 512
            },
            mobile: {
                width: 380,
                height: 300
            }
        }
    })), !isExtendedLoaded && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        coverMode: true
    }));
};
StatusFullView.displayName = 'StatusFullView';
export default StatusFullView;

//# sourceMappingURL=Status.js.map